import WizCo from '@webcarelbj/wizco'

export default defineNuxtPlugin({
  name: 'wizco',
  dependsOn: ['storyblok'],
  setup(nuxtApp) {
    const { environment, host, path } = usePageEnvironment()
    const config = getPageConfig(environment, host, path)
    if (config === undefined) {
      return
    }

    const { apiDomain, listApiDomain, apiDomainDecision, apiDomainProduct, wizcoAccessToken } = useRuntimeConfig().public

    nuxtApp.vueApp.use(WizCo, {
      storyblokVersion: config.storyblok.accessLevel,
      storyblokAccessToken: wizcoAccessToken,
      apiDomain,
      listApiDomain,
      disableStoryblokPlugin: true,
      apiDomainDecision,
      apiDomainProduct,
    })
  },
})
